import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site-config';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20red%20velvet%20curtains%20and%20spotlight%2C%20mysterious%20entertainment%20news%20studio%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20broadcast%20setting%2C%20elegant%20dark%20red%20and%20black%20color%20scheme%2C%20film%20grain%20texture%20overlay%2C%20dramatic%20theatrical%20mood&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="51吃瓜官网 - 全网独家吃瓜爆料入口"
          title="51吃瓜官网-全网独家吃瓜爆料入口"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto pt-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-label font-medium mb-6 md:mb-8 backdrop-blur-sm">
            <i className="ri-fire-line"></i>
            <span>全网独家吃瓜爆料入口已更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 md:mb-6">
            全网独家吃瓜爆料入口
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-background-50/90 mb-3 md:mb-4">
            51吃瓜官网带你直击第一现场
          </p>

          <p className="text-sm md:text-base text-background-50/70 max-w-2xl leading-relaxed mb-8 md:mb-10">
            {siteConfig.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
            <Link
              to="/category/latest"
              className="px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-label font-semibold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              在线观看
            </Link>
            <Link
              to="/category/morisxiu"
              className="px-8 py-3 md:px-10 md:py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 text-sm md:text-base font-label font-medium rounded-full border border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              莫里秀独家
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-6 md:pb-8">
        <div className="max-w-6xl mx-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20scene%20with%20flashing%20cameras%20on%20red%20carpet%2C%20dramatic%20night%20event%20photography%2C%20crowd%20of%20journalists%20and%20photographers%2C%20cinematic%20lighting%20with%20warm%20and%20cool%20contrast%2C%20film%20grain%20texture%2C%20editorial%20photojournalism%20style&width=1200&height=400&seq=hero-bottom-strip&orientation=landscape"
            alt="娱乐爆料现场"
            title="51吃瓜莫里秀-大英博物馆爆料现场"
            className="w-full h-48 md:h-64 object-cover object-top rounded-2xl md:rounded-3xl opacity-90"
          />
        </div>
      </div>
    </section>
  );
}